import AppConstants from '../Constants/AppConstants';

const key = () => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:account-configs`;
export const readAccountConfigurationDraft = () => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(key());
    if (!raw) return {};
    const value = JSON.parse(raw);
    if (!value || typeof value !== 'object') return {};
    const draft = {};
    ['accountDetailNote', 'addressLabel', 'categoryLabel', 'nearRadiusKm', 'accountLimit', 'shippingPreferenceNote'].forEach(field => {
      if (typeof value[field] === 'string') draft[field] = value[field];
    });
    if (Array.isArray(value.statusArray)) draft.statusArray = Array.from({length: 10}, (_, index) => Boolean(value.statusArray[index]));
    return draft;
  } catch (error) {
    return {};
  }
};
export const writeAccountConfigurationDraft = value => {
  if (typeof window === 'undefined') return;
  try {
    const {accountDetailNote, addressLabel, categoryLabel, nearRadiusKm, accountLimit, shippingPreferenceNote, statusArray} = value;
    const draft = {accountDetailNote, addressLabel, categoryLabel, nearRadiusKm, accountLimit, shippingPreferenceNote, statusArray};
    if (JSON.stringify(draft).length < 100000) window.localStorage.setItem(key(), JSON.stringify(draft));
  } catch (error) {
    // Keep account settings usable when browser storage is unavailable.
  }
};
export const clearAccountConfigurationDraft = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(key());
  } catch (error) {
    // Ignore storage errors after the save succeeds.
  }
};
